export default __webpack_public_path__ + "static/media/TUNE_ROCK_120X278_02_265.a13979fe.jpg";